import { render, staticRenderFns } from "./auto_staking.vue?vue&type=template&id=20418d56&"
import script from "./auto_staking.vue?vue&type=script&lang=js&"
export * from "./auto_staking.vue?vue&type=script&lang=js&"
import style0 from "./auto_staking.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports